import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { DisplayAccordion } from "./DisplayAccordion";
import { SlideOut } from "../SlideOut/SlideOut";
import { EditAccordion } from "./EditAccordion";
import { NothingToDisplay } from "../NothingToDisplay/NothingToDisplay";
import type { IHomePageData } from "../../pages/public/HomePage/HomePage";
import { HomePageTitle } from "../../layout/publicPageLayout";
import { Edit } from "../HeroSection/HeroComponent";
import { EditButton } from "../Buttons/Buttons";

interface IEditableAccordionProps {
  homePageData: IHomePageData;
  isEditable: boolean;
}

export function DisplayAndEditAccordion({
  homePageData,
  isEditable,
}: IEditableAccordionProps) {
  const { t } = useTranslation();
  const [editMode, setEditMode] = useState(false);
  const startEditMode = () => setEditMode(true);
  const endEditMode = () => setEditMode(false);

  const component = homePageData.config.components.find(
    (component) => component.name === "accordion"
  );

  if (component && component?.data?.accordionContent?.length === 0) {
    return (
      <>
        <SlideOut
          title={t("Edit FAQ")}
          closeFlyout={endEditMode}
          show={editMode}
        >
          {/* need to give EditAccordion everything so it can make the PUT
           request */}
          <EditAccordion components={homePageData} endEditMode={endEditMode} />
        </SlideOut>
        {isEditable && (
          <Edit>
            <EditButton
              testid={"edit-accordion-section"}
              onClick={startEditMode}
            />
          </Edit>
        )}
        <HomePageTitle>
          {component?.data?.header || "Frequently Asked Questions"}
        </HomePageTitle>
        <NothingToDisplay />
      </>
    );
  } else {
    const data = component?.data;
    const header = data?.header ?? "Frequently Asked Question";
    const accordionContent = data?.accordionContent ?? [];

    // props to control behavior of accordion.
    const collapsible = data?.collapsible;
    const multiple = data?.multiple;

    return (
      <>
        <SlideOut
          title={t("Edit FAQ")}
          closeFlyout={endEditMode}
          show={editMode}
        >
          <EditAccordion components={homePageData} endEditMode={endEditMode} />
        </SlideOut>
        {isEditable && (
          <Edit>
            <EditButton
              testid={"edit-accordion-section"}
              onClick={startEditMode}
            />
          </Edit>
        )}
        <DisplayAccordion
          collapsible={collapsible}
          multiple={multiple}
          header={header}
          accordionContent={accordionContent}
        />
      </>
    );
  }
}
